import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { Button } from '@superdispatch/ui-lab';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';

interface LoginErrorDialogProps {
  title: string;
  message?: string;
  onClose: () => void;
}

export function LoginErrorDialog({
  title,
  message,
  onClose,
}: LoginErrorDialogProps) {
  const { showLauncherMessanger } = useCustomerSupport();
  return (
    <Dialog open={!!message} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button
          variant="neutral"
          onClick={() => {
            onClose();
            showLauncherMessanger();
          }}
        >
          Contact Support
        </Button>

        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
